import { Check, Cloud, CreditCard, MessageSquare } from 'lucide-react';

export function ManagedPlanCard({ service, onSubscribe, onTalk }) {
  return (
    <div className="nw-card grid md:grid-cols-5 gap-8 p-8 md:p-10" data-testid="managed-web-services-card">
      <div className="md:col-span-3">
        <Cloud size={28} strokeWidth={1.5} className="text-[#00f0ff] mb-4" />
        <p className="font-tech text-xs uppercase tracking-[0.25em] text-[#ff00ff] mb-2">Monthly retainer</p>
        <h3 className="font-heading text-3xl font-bold text-white mb-3">{service.name}</h3>
        <p className="text-slate-300 mb-6 max-w-lg">{service.description}</p>
        <ul className="grid sm:grid-cols-2 gap-3">
          {service.features.map((f) => (
            <li key={f} className="flex items-start gap-2.5 text-sm text-slate-200">
              <Check size={16} className="text-[#00f0ff] mt-0.5 shrink-0" /> {f}
            </li>
          ))}
        </ul>
      </div>
      <div className="md:col-span-2 flex flex-col justify-center border-t md:border-t-0 md:border-l border-[#00f0ff]/20 pt-8 md:pt-0 md:pl-8">
        <p className="font-display text-5xl font-extrabold text-white">
          ${service.base_price}<span className="text-lg text-slate-400">/mo</span>
        </p>
        <p className="font-tech text-xs uppercase tracking-wider text-slate-400 mt-1 mb-6">Baseline · cancel any time</p>
        <button
          onClick={onSubscribe}
          className="nw-btn mb-3 flex items-center justify-center gap-2 px-4 py-3 bg-[#00f0ff] text-[#0a0a1f] hover:bg-white font-tech uppercase tracking-wider text-sm"
          data-testid="btn-subscribe-managed-web"
        >
          <CreditCard size={16} /> Subscribe monthly
        </button>
        <button
          onClick={onTalk}
          className="nw-btn flex items-center justify-center gap-2 px-4 py-3 border border-[#ff00ff] text-[#ff00ff] hover:bg-[#ff00ff] hover:text-[#0a0a1f] font-tech uppercase tracking-wider text-sm"
          data-testid="btn-talk-first-managed-web"
        >
          <MessageSquare size={16} /> Talk to us first
        </button>
      </div>
    </div>
  );
}
